
import { defineComponent, ref, reactive, watch } from "vue";
import { Plus } from "@element-plus/icons-vue";
import type { UploadProps, UploadUserFile, FormRules, FormInstance } from "element-plus";
import WangEditor from "@/components/WangEditor/index.vue";
import SpeciFications from "@/components/SpeciFications/index.vue";
import { useRoute, useRouter } from "vue-router";
import { listSimple, brandlist, addProduct, edProduct, shopgtedit, putProduct } from "@/api/Commodityallocation";
import { ElMessage } from "element-plus";
import { UploadUrl } from "@/utils/request";
export default defineComponent({
  name: "details",
  components: { Plus, WangEditor, SpeciFications },
  setup() {
    const ruleFormRef = ref<FormInstance>();
    const rules = reactive<FormRules>({
      title: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
      viceTitle: [{ required: true, message: "请输入商品副标题", trigger: "blur" }],
      indexTitle: [{ required: true, message: "请输入首页标题", trigger: "blur" }],
      indexViceTitle: [{ required: true, message: "请输入首页副标题", trigger: "blur" }],
      brandNo: [{ required: true, message: "请选择商品品牌", trigger: "change" }],
      keyword: [{ required: true, message: "请输入商品关键词", trigger: "blur" }],
    });
    const router = useRouter();
    const route = useRoute();
    const Disabledisplay = ref<boolean>(false);
    const dialogTitle = ref<string>("");
    const addFormData = ref<any>({
      goodsTypeId: "",
      goodsTypeId2: "",
      goodsTypeId3: "",
      code: "",
      afterSaleService: "",
      fiveImg: "",
      imgTextIntro: "",
      planImg: "",
      title: "",
      activityDescription: "",
      apiProductVos: [], //规格表格数据
      apiShopSpecProducts: [], //规格属性数据
      indexTitle: "",
      indexViceTitle: "",
      productSpecVo: {},
      viceTitle: "",
    });

    const isdisabled1 = ref(false);
    const isdisabled2 = ref(false);
    const isdisabled3 = ref(false);
    // 分类下拉参数
    const listSimpleForm = ref<Req.listSimple>({
      parentId: 0,
      merchantId: 0,
    });
    // 回显编辑
    const getedProduct = () => {
      if (route.query.code) {
        edProduct(route.query.code as string).then(async (res) => {
          addFormData.value = res.data;
          if (addFormData.value.fiveImg) {
            fiveImg.value = addFormData.value.fiveImg.split(",").map((item: any) => {
              return {
                url: item,
              };
            });
          } else {
            addFormData.value.fiveImg = "";
          }
          // console.log(fiveImg.value, "33333333333333333333333");

          // 回显三级联动下拉
          await shopgtedit(addFormData.value.goodsTypeId).then(async (res) => {
            // console.log(res);
            if (res.data.level == 1) {
              addFormData.value.goodsTypeId = res.data?.id;
              await listSimple({ parentId: 0, merchantId: 0 }).then((res) => {
                // 第一级获得二级
                listSimpleArr1.value = res.data;
                isdisabled1.value = true;
                isdisabled2.value = true;
                isdisabled3.value = true;
              });
            } else if (res.data.level == 2) {
              addFormData.value.goodsTypeId2 = res.data?.id;
              // listSimpleForm.value.parentId = res.parentId as number;
              await listSimple({ parentId: res.data.parentId, merchantId: 0 }).then(async (res2) => {
                // 第一级获得二级
                listSimpleArr2.value = res2.data;
                isdisabled2.value = true;
                addFormData.value.goodsTypeId = res.data.parentId;
                await shopgtedit(res.data.parentId).then(async (res3) => {
                  listSimpleArr1.value = res2.data;
                  isdisabled1.value = true;
                  isdisabled3.value = true;
                });
              });
            } else if (res.data.level == 3) {
              addFormData.value.goodsTypeId3 = res.data?.id;
              // listSimpleForm.value.parentId = res.parentId as number;
              await listSimple({ parentId: res.data.parentId, merchantId: 0 }).then(async (res2) => {
                addFormData.value.goodsTypeId2 = res.data.parentId;
                listSimpleArr3.value = res2.data;
                isdisabled3.value = true;
                await shopgtedit(res.data.parentId).then(async (res3) => {
                  addFormData.value.goodsTypeId = res3.data.parentId;
                  listSimple({ parentId: res3.data.parentId, merchantId: 0 }).then(async (res4) => {
                    listSimpleArr2.value = res4.data;
                    isdisabled2.value = true;
                    await shopgtedit(res3.data.parentId).then(async (res5) => {
                      listSimpleArr1.value = res5.data;
                      isdisabled1.value = true;
                    });
                  });
                });
              });
            }
          });
          // console.log(addFormData.value.imgTextIntro);
        });
      }
    };
    getedProduct();
    // 图标
    const img = ref("/compontsimg/fl.png");
    const img2 = ref("/compontsimg/jbxx.png");
    const img3 = ref("/compontsimg/gg.png");
    const img4 = ref("/compontsimg/ttsc.png");
    const img5 = ref("/compontsimg/twjs.png");
    const img6 = ref("/compontsimg/shbz.png");

    const submitTableData = ref<any>();

    // 三级下拉类别
    const listSimpleArr1 = ref<any>();
    const listSimpleArr2 = ref<any>();
    const listSimpleArr3 = ref<any>();

    // 联动分类
    const getMyClass = (key?: number, val?: number) => {
      // 获取一级下拉
      listSimple(listSimpleForm.value).then((res) => {
        // 第一级获得二级
        if (key == 1) {
          listSimpleArr2.value = res.data;
          // console.log(listSimpleArr2.value);
          addFormData.value.goodsTypeId2 = "";
          addFormData.value.goodsTypeId3 = "";
          // 点二级获得三级
        } else if (key == 2) {
          listSimpleArr3.value = res.data;
          addFormData.value.goodsTypeId3 = "";
        } else if (key == 3) {
          return;
        } else {
          listSimpleArr1.value = res.data;
        }
      });
    };
    getMyClass();
    const changeSelect = (value: any, num: number) => {
      listSimpleForm.value.parentId = value;
      getMyClass(num, value);
      // console.log(value);
      getSelectName(num, value);
    };
    const SelectName = ref("");
    const SelectName2 = ref("");
    const SelectName3 = ref("");
    const getSelectName = (num: number, val: number) => {
      if (num == 1) {
        listSimpleArr1.value.map((item: any) => {
          if (item.id == val) {
            SelectName.value = item.name;
          }
        });
        SelectName2.value = "";
        SelectName3.value = "";
      } else if (num == 2) {
        listSimpleArr2.value.map((item: any) => {
          if (item.id == val) {
            SelectName2.value = " > " + item.name;
          }
        });
        SelectName3.value = "";
      } else {
        listSimpleArr3.value.map((item: any) => {
          if (item.id == val) {
            SelectName3.value = " > " + item.name;
          }
        });
      }
    };
    const isImage = ref(false);
    // 商品品牌下拉
    const brandlistData = ref();
    const bardSelect = (value: any) => {
      // console.log(value);
    };
    // 获取品牌下拉
    const getbrandlist = () => {
      brandlist({ baseDto: { pageNum: 1, pageSize: 999999 } }).then((res) => {
        brandlistData.value = res.data.data;
      });
    };
    getbrandlist();

    // 上传商品图册
    const fiveImg = ref<any>([]);
    const imgViewerVisible = ref(false);
    const handleRemove: UploadProps["onRemove"] = (uploadFile: any, uploadFiles) => {
      // console.log(uploadFile.response.fileUrl);
      fiveImg.value.map((item: any, index: number) => {
        if (item.url == uploadFile.response.fileUrl) {
          fiveImg.value.splice(index, 1);
        }
      });
      // console.log(uploadFiles);
      // console.log(fiveImg.value);
    };
    const handleSuccess = (response: { fileUrl: string; code: number }) => {
      console.log(response.fileUrl);

      // if (response.code == 1) {
      //   fiveImg.value.push({ url: response.fileUrl });
      // }
      // fiveImg.value.map((item: any, index: number) => {
      //   if (item.raw) {
      //     fiveImg.value.splice(index, 1);
      //   }
      // });
      // fiveImg.value.push({ url: response.fileUrl });
      console.log(fiveImg.value);
      fiveImg.value.forEach((item: any) => {
        if (item.response) {
          item.url = item.response.fileUrl;
        }
      });
    };
    const MyfiveImg = ref<any>([]);
    const handlePictureCardPreview = (uploadFile: { url: string }) => {
      console.log(uploadFile);
      MyfiveImg.value = [];
      imgViewerVisible.value = true;
      MyfiveImg.value.unshift(uploadFile.url);
      fiveImg.value.forEach((item: any, index: any) => {
        MyfiveImg.value.push(item.url);
      });
    };
    const WangEditorURl = (val: any) => {
      // console.log(val);
    };
    // 提交表单
    const submitForm = async (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      await formEl.validate((valid: any, fields: any) => {
        if (!addFormData.value.goodsTypeId) {
          Disabledisplay.value = true;
          dialogTitle.value = "请选择商品分类";
          isImage.value = true;
          return;
        } else {
          isImage.value = false;
        }
        if (valid) {
          if (!fiveImg.value) {
            Disabledisplay.value = true;
            dialogTitle.value = "请上传商品图册";
            return;
          }
          // 图片数组转字符串
          addFormData.value.fiveImg = "";
          addFormData.value.fiveImg += fiveImg.value.map((item: any, index: number) => {
            return item.url;
          });

          // console.log(submitTableData.value, "--------------------------------------");
          if (submitTableData.value) {
            addFormData.value.apiProductVos = [];
            addFormData.value.apiShopSpecProducts = [];
            submitTableData.value.forEach((item: any) => {
              // console.log(item, "999999999999999999999999999999999999999999999999999999999999999999");

              //  apiProductVos
              let obj = {
                apiProduct: {
                  code: route.query.code,
                  id: item.productId,
                  isSubscribe: "00",
                  officialPrice: item.officialPrice,
                  preSale: "",
                  price: item.price,
                  productImg: item.productImg,
                  sku: item.sku,
                },
                // filmYearCardId: "",
                // productInsuranceList: [],
                // productLimit: {},
                // promotions: [],
                // saleVo: {},
              };
              addFormData.value.apiProductVos.push(obj);
              // for (let i = 0; i < addFormData.value.apiProductVos.length; i++) {
              //   addFormData.value.apiProductVos[i].apiProduct = objval;
              //   continue;
              // }

              for (const key in item) {
                if (key == "颜色" && item.颜色 !== "") {
                  let apiShopSpecProductsobj = {
                    code: route.query.code || "",
                    id: "",
                    specId: 0,
                    specItemName: "",
                  };
                  apiShopSpecProductsobj.specId = 1;
                  apiShopSpecProductsobj.specItemName = item.颜色;
                  addFormData.value.apiShopSpecProducts.push(apiShopSpecProductsobj);
                } else if (key == "内存" && item.内存 !== "") {
                  let apiShopSpecProductsobj = {
                    code: route.query.code || "",
                    id: "",
                    specId: 0,
                    specItemName: "",
                  };
                  apiShopSpecProductsobj.specId = 2;
                  apiShopSpecProductsobj.specItemName = item.内存;
                  addFormData.value.apiShopSpecProducts.push(apiShopSpecProductsobj);
                } else if (key == "容量" && item.容量 !== "") {
                  let apiShopSpecProductsobj = {
                    code: route.query.code || "",
                    id: "",
                    specId: 0,
                    specItemName: "",
                  };
                  apiShopSpecProductsobj.specId = 3;
                  apiShopSpecProductsobj.specItemName = item.容量;
                  addFormData.value.apiShopSpecProducts.push(apiShopSpecProductsobj);
                } else if (key == "材质" && item.材质 !== "") {
                  let apiShopSpecProductsobj = {
                    code: route.query.code || "",
                    id: "",
                    specId: 0,
                    specItemName: "",
                  };
                  apiShopSpecProductsobj.specId = 4;
                  apiShopSpecProductsobj.specItemName = item.材质;
                  addFormData.value.apiShopSpecProducts.push(apiShopSpecProductsobj);
                } else if (key == "规格" && item.规格 !== "") {
                  let apiShopSpecProductsobj = {
                    code: route.query.code || "",
                    id: "",
                    specId: 0,
                    specItemName: "",
                  };
                  apiShopSpecProductsobj.specId = 5;
                  apiShopSpecProductsobj.specItemName = item.规格;
                  addFormData.value.apiShopSpecProducts.push(apiShopSpecProductsobj);
                } else if (key == "版本" && item.版本 !== "") {
                  let apiShopSpecProductsobj = {
                    code: route.query.code || "",
                    id: "",
                    specId: 0,
                    specItemName: "",
                  };
                  apiShopSpecProductsobj.specId = 6;
                  apiShopSpecProductsobj.specItemName = item.版本;
                  addFormData.value.apiShopSpecProducts.push(apiShopSpecProductsobj);
                }
              }
            });
            for (let i = 0; i < addFormData.value.apiShopSpecProducts.length; i++) {
              for (let j = i + 1; j < addFormData.value.apiShopSpecProducts.length; j++) {
                if (addFormData.value.apiShopSpecProducts[i].specItemName == addFormData.value.apiShopSpecProducts[j].specItemName) {
                  addFormData.value.apiShopSpecProducts.splice(j, 1);
                  --j;
                }
              }
            }
          } else {
            Disabledisplay.value = true;
            dialogTitle.value = "请选择商品规格属性！";
            return;
          }

          // submitTableData.value.forEach((item:any)=>{
          // addFormData.value.apiProductVos.push({})
          // })

          if (addFormData.value.goodsTypeId3) {
            addFormData.value.goodsTypeId = addFormData.value.goodsTypeId3;
          } else if (addFormData.value.goodsTypeId2) {
            addFormData.value.goodsTypeId = addFormData.value.goodsTypeId2;
          }
          delete addFormData.value.goodsTypeId2;
          delete addFormData.value.goodsTypeId3;

          if (route.query.code) {
            putProduct(addFormData.value).then((res) => {
              if (res.code == 1) {
                ElMessage({
                  message: res.msg as string,
                  type: "success",
                });
                if (route.query.distinguish) {
                  router.push("/Commodityallocation/examine");
                } else {
                  router.push("/Commodityallocation/stock");
                }
              } else {
                ElMessage({
                  message: res.msg as string,
                  type: "warning",
                });
              }
              // console.log(res);
            });
          } else {
            addProduct(addFormData.value).then((res) => {
              if (res.code == 1) {
                ElMessage({
                  message: res.msg as string,
                  type: "success",
                });
                router.push("/Commodityallocation/stock");
              } else {
                ElMessage({
                  message: res.msg as string,
                  type: "warning",
                });
              }
              // console.log(res);
            });
          }
        } else {
          addFormData.value.fiveImg = fiveImg.value.join(",");
          // console.log("error submit!", fields);
          console.log(addFormData.value);
          Disabledisplay.value = true;
          dialogTitle.value = "基本信息未补全";
        }
      });
    };
    const beforeAvatarUpload = (rawFile: { type: any; size: number }) => {
      console.log(rawFile.type !== "image/jpeg");
      console.log(rawFile.type);
      if (rawFile.type !== "image/jpeg" && rawFile.type !== "image/png") {
        ElMessage.error("请上传正确图片格式!");
        return false;
      }
      console.log(rawFile.size);
      if (rawFile.size > 2048 * 1000) {
        ElMessage.error(`图片大小不能超过2M`);
        return false;
      }
      return true;
    };
    return {
      img,
      img2,
      img3,
      img4,
      img5,
      img6,
      handleRemove,
      handlePictureCardPreview,
      imgViewerVisible,
      changeSelect,
      addFormData,
      listSimpleArr1,
      listSimpleArr2,
      listSimpleArr3,
      bardSelect,
      brandlistData,
      handleSuccess,
      MyfiveImg,
      submitForm,
      submitTableData,
      beforeAvatarUpload,
      route,
      fiveImg,
      Disabledisplay,
      dialogTitle,
      isdisabled1,
      isdisabled2,
      isdisabled3,
      rules,
      ruleFormRef,
      SelectName,
      SelectName2,
      SelectName3,
      WangEditorURl,
      isImage,
      UploadUrl,
    };
  },
});
